import { render } from "./project-list.html?vue&type=template&id=278e4372&scoped=true&ts=true"
import script from "./project-list.ts?vue&type=script&lang=ts"
export * from "./project-list.ts?vue&type=script&lang=ts"

import "./project-list.scss?vue&type=style&index=0&id=278e4372&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-278e4372"]])

export default __exports__